<div class="px-4 py-24 sm:px-6 lg:px-8 max-w-7xl mx-auto">
  <div class="sm:flex sm:items-center">
    <div class="sm:flex-auto">
      <h1 class="text-base font-semibold text-gray-900">Settings</h1>
      
    </div>
    
  </div>
  <div class="mt-8 flow-root">
    <div class="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
      <div class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">

        <div class="flex justify-between">
          <div class="">Reindex Customers</div>
          <div class="">
            
            <button type="button" (click)="reindexCustomersClicked()" class="block rounded-md bg-accent px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-gray-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 ">Begin Reindex</button>
          </div>
        </div>
        
      </div>
    </div>
  </div>
</div>